/**
 * Tag rates for the Tags page (#172): permits with the tag in the last 12
 * months per 10,000 residents of the jurisdictions we cover, by state and by
 * county. A state where we cover under 40% of people is "thin coverage".
 */
export const THIN_COVERAGE_SHARE = 0.4;
/**
 * Covered population per county from permits.json jurisdictions (credited
 * ones only): county rows count for themselves, county subdivisions for the
 * county in their GEOID, and places split across counties by population.
 */
export function coveredPopulationByCounty(jurisdictions, placeCountyParts) {
    const parts = new Map();
    for (const p of placeCountyParts)
        parts.set(p.place_geoid, [...(parts.get(p.place_geoid) ?? []), p]);
    const out = {};
    const add = (fips, n) => {
        if (n > 0)
            out[fips] = (out[fips] ?? 0) + n;
    };
    for (const j of jurisdictions) {
        if (j.thin_partial || j.population <= 0)
            continue;
        const g = j.place_geoid;
        if (g.length === 5)
            add(g, j.population);
        else if (g.length === 10)
            add(g.slice(0, 5), j.population);
        else {
            const ps = parts.get(g) ?? [];
            const total = ps.reduce((n, p) => n + p.population, 0);
            for (const p of ps)
                add(p.county_fips, total > 0 ? Math.round((j.population * p.population) / total) : 0);
        }
    }
    return out;
}
export function stateRates(stat, stats) {
    return Object.entries(stats.state_coverage)
        .map(([state, c]) => {
        const n12 = stat.by_state[state] ?? 0;
        const share = c.total_population > 0 ? c.covered_population / c.total_population : 0;
        return {
            state,
            n12,
            per10k: c.covered_population > 0 ? (n12 / c.covered_population) * 10_000 : 0,
            share_covered: share,
            thin: share < THIN_COVERAGE_SHARE,
        };
    })
        .sort((a, b) => b.per10k - a.per10k || a.state.localeCompare(b.state));
}
export function countyRates(stat, stats, state) {
    return Object.entries(stats.county_coverage)
        .filter(([, c]) => c.state === state && c.covered_population > 0)
        .map(([fips, c]) => {
        const n12 = stat.by_county[fips] ?? 0;
        return { fips, name: c.name, n12, per10k: (n12 / c.covered_population) * 10_000 };
    })
        .filter((c) => c.n12 > 0)
        .sort((a, b) => b.per10k - a.per10k);
}
//# sourceMappingURL=rates.js.map